import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-dark-surface border-t border-dark-border">
      <div className="w-full px-4 md:px-8 py-10 md:py-12">
        <div className="flex flex-col items-center justify-center text-center gap-5">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3">
            <img
              src="https://storage.readdy-site.link/project_files/ea9bd2f5-a5fa-48e1-adb8-14e6c6a8dddd/39001f87-94f8-4788-9d8a-585e79d11d93_logo.png?v=4a092eb770424da0016aa1f907a04388"
              alt="할매티비 스포츠중계"
              width="40"
              height="40"
              className="w-10 h-10 rounded-md"
            />
            <span className="text-white font-bold text-lg">
              할매티비 스포츠중계
            </span>
          </Link>

          {/* Links */}
          <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6">
            <Link
              to="/"
              className="text-dark-text-muted text-sm hover:text-brand-orange transition-colors"
            >
              홈
            </Link>
            <Link
              to="/sports-schedule"
              className="text-dark-text-muted text-sm hover:text-brand-orange transition-colors"
            >
              오늘의 일정
            </Link>
            <Link
              to="/live-score"
              className="text-dark-text-muted text-sm hover:text-brand-orange transition-colors"
            >
              라이브스코어
            </Link>
            <Link
              to="/lineup"
              className="text-dark-text-muted text-sm hover:text-brand-orange transition-colors"
            >
              라인업
            </Link>
            <Link
              to="/missing-players"
              className="text-dark-text-muted text-sm hover:text-brand-orange transition-colors"
            >
              결장자
            </Link>
            <Link
              to="/live-tv"
              className="text-dark-text-muted text-sm hover:text-brand-orange transition-colors"
            >
              실시간방송
            </Link>
          </div>

          {/* Copyright */}
          <p className="text-dark-text-muted text-sm pt-4 border-t border-dark-border w-full max-w-md">
            Copyright &copy; 1999 할매티비 | Powered by [
            <Link
              to="/"
              className="text-brand-orange hover:text-brand-orange-hover transition-colors"
            >
              스포츠중계
            </Link>
            ]
          </p>
        </div>
      </div>
    </footer>
  );
}